module.exports = __webpack_public_path__ + "img/renmingbaoxian.fdd62d36.png";